import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.campaigns.edit', []).controller('CampaignsEditCtrl', CampaignsEditCtrl)

/** @ngInject */
function CampaignsEditCtrl(
  $scope,
  $state,
  $stateParams,
  $q,
  $rootScope,
  $timeout,
  CampaignsService,
  ChannelGroupChildrenService,
  PublisherAdminService,
) {
  var vm = this
  vm.model = {}
  vm.id = parseInt($stateParams.id)
  vm.isOpen = false
  vm.publishers = []
  vm.channels = []
  vm.affiliateList = []

  vm.campaignsTypes = [
    {
      id: 0,
      name: 'General',
    },
    {
      id: 1,
      name: 'Affiliate',
    },
  ]

  ChannelGroupChildrenService.listChannel().then(function (result) {
    vm.channels = result.results
  })

  $rootScope.$on('affiliateList', function (event, data) {
    vm.affiliateList = data
  })

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  if (vm.id !== 0) {
    CampaignsService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      if (vm.model['ts-x'] !== undefined && vm.model['ts-x'] !== 0) {
        vm.model['ts-x'] = vm.model['ts-x']
          .toString()
          .substring(0, vm.model['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(vm.model['ts-x']))
        vm.data1 = angular.copy(vm.model['ts-x'])
      }

      $('#affiliate').select2('data', vm.model.pcaf)
    })
  }

  PublisherAdminService.listAll().then(function (result) {
    vm.publishers = result.results
  })

  vm.save = function () {
    var model = angular.copy(vm.model)
    if (
      model.t === undefined ||
      model.sn === undefined ||
      model.txt === undefined ||
      model['id-pu'] === undefined
    ) {
      swal('Required title, short title, description, publisher fields', '', 'error')
      return
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-x'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      swal('Required date field.', '', 'error')
      return
    }

    var listAffiliates = $('#affiliate').select2('val')
    var modelAffiliates = []
    if (listAffiliates !== undefined) {
      if (vm.model.pcaf !== undefined) {
        for (var i = 0; i < vm.model.pcaf.length; i++) {
          for (var j = 0; j < listAffiliates.length; j++) {
            if (parseInt(listAffiliates[j]) === vm.model.pcaf[i].id) {
              modelAffiliates.push(vm.model.pcaf[i])
            }
          }
        }
      }

      for (var i = 0; i < vm.affiliateList.length; i++) {
        for (var j = 0; j < listAffiliates.length; j++) {
          if (parseInt(listAffiliates[j]) === vm.affiliateList[i].id) {
            modelAffiliates.push(vm.affiliateList[i])
          }
        }
      }
    }

    modelAffiliates = _.uniqBy(modelAffiliates, 'id')

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      CampaignsService.update(model.id, model).then(function () {
        CampaignsService.addPromoCampaignAffiliate(model.id, modelAffiliates).then(function () {
          $timeout(function () {
            $state.go('admin.promo_campaigns')
          }, 500)
        })
      })
    } else {
      CampaignsService.save(model).then(function (result) {
        CampaignsService.addPromoCampaignAffiliate(result.results.id, modelAffiliates).then(
          function () {
            $timeout(function () {
              $state.go('admin.promo_campaigns')
            }, 500)
          },
        )
      })
    }
  }

  vm.cancel = function () {
    $state.go('admin.promo_campaigns')
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
  })
}
